export enum LocationRoutes {
  Root = '',
  Printers = 'printers',
  PrinterSettings = 'printer/settings',
  CashPoints = 'cash-points',
  CashPointsClosingAssistant = 'cash-points/assistant/closing',
  Events = 'events',
  EventDetails = 'event/summary',
  BookingEntityOverview = 'booking-entities',
  TableLayout = 'table-layout'
}
